import React from "react";

/**
 * Context to share the account information between all components
 */
export const AccountContext = React.createContext<Readonly<any>>({
    token: "",
    setToken: function(value: string) {},
    accountId: 0,
    setAccountID: function(value: number) {},
    adId: "",
    setIsExpiredToken(value: boolean) {},
    isExpired: false, // If the WLD API's token is not the same than user, expiredToken will be true and a modal will be displayed i
    setAdID: function(value: string) {},
    displayName: "",
    setDisplayName: function(value: string) {},
    roles: [],
    setRoles: function(value: []) {}
});